<div class="camera-container">
  <!-- Preview da foto capturada -->
  <div *ngIf="capturedPhoto && !isCameraActive" class="photo-preview">
    <img [src]="capturedPhoto" alt="Captured photo" class="captured-image" />
    
    <div class="preview-actions">
      <button mat-raised-button color="primary" (click)="retakePhoto()">
        <mat-icon>camera_alt</mat-icon>
        Tirar nova foto
      </button>
    </div>
  </div>

  <!-- Camera ativa -->
  <div *ngIf="isCameraActive" class="camera-section">
    <div class="camera-view">
      <video
        #videoElement
        autoplay
        playsinline
        class="video-element"
      ></video>
    </div>

    <div class="camera-controls" *ngIf="!isLoading">
      <button
        mat-fab
        color="primary"
        (click)="capturePhoto()"
        [disabled]="isLoading"
        class="capture-btn"
        aria-label="Capture photo"
      >
        <mat-icon>camera</mat-icon>
      </button>

      <button
        *ngIf="hasMultipleCameras"
        mat-mini-fab
        (click)="switchCamera()"
        [disabled]="isLoading"
        class="switch-btn"
        aria-label="Switch camera"
      >
        <mat-icon>flip_camera_android</mat-icon>
      </button>

      <button
        mat-mini-fab
        color="warn"
        (click)="stopCamera()"
        [disabled]="isLoading"
        class="close-btn"
        aria-label="Close camera"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Botão para abrir câmera quando não está ativa e não tem foto -->
  <div *ngIf="!isCameraActive && !capturedPhoto" class="start-camera">
    <button
      mat-raised-button
      color="primary"
      (click)="startCamera()"
      [disabled]="isLoading"
      class="start-camera-btn"
    >
      <mat-icon>camera_alt</mat-icon>
      Abrir câmera
    </button>
  </div>

  <!-- Loading spinner -->
  <div *ngIf="isLoading" class="loading-overlay">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</div>
